import { renderToString } from 'react-dom/server';
import AmazonCard from './AmazonCard';

export const isUserFromUs = (articleId) => {
  let timeZone = '';
  if (Intl && Intl.DateTimeFormat)
    timeZone = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone;
  else timeZone = 'NA';
  const isUsUser = timeZone.includes('America');
  const validArticles =
    articleId == 167722 ||
    articleId == 192289 ||
    articleId == 168665 ||
    articleId == 168499;
  return isUsUser;
};
export const isUserFromIndia = () => {
  let timeZone = '';
  if (Intl && Intl.DateTimeFormat)
    timeZone = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone;
  else timeZone = 'NA';
  console.log(timeZone);
  const isIndianUser =
    timeZone.includes('Asia/Kolkata') ||
    timeZone.includes('Asia/Calcutta') ||
    timeZone.includes('Asia/calcutt');
  return isIndianUser;
};
const carouselData167722 = [
  {
    image: 'https://images.myloapp.in/NestJsUploads/1712766719379-Amazon1.webp',
    text: 'Natalist Pregnancy Tests Early Home Detection Kit for Women - Rapid Clear & Accurate Results Help Ease Your Mind up to 5 Days Before Expected Period - 2 Count (5)',
    link: 'https://amzn.to/3JkTlwE',
    id: 0,
  },
  {
    image: 'https://images.myloapp.in/NestJsUploads/1712766719378-Amazon2.webp',
    text: 'The Ultimate Pregnancy Test Kit',
    link: 'https://amzn.to/3JlmJm8',
    id: 1,
  },
  {
    image: 'https://images.myloapp.in/NestJsUploads/1712766719378-Amazon3.webp',
    text: 'Fairhaven Health BFP Kit - 40 Ovulation and 10 Pregnancy Test Strips – Monitor LH and HCG Levels- Early Detection at Home for Women Trying to Get Pregnant - Made in North America',
    link: 'https://amzn.to/3xyklWx',
    id: 2,
  },
  {
    image: 'https://images.myloapp.in/NestJsUploads/1712766719375-Amazon4.webp',
    text: 'Bird&Be Pregnancy Test Strips for Early Detection (20-Pack Kit, FSA-Eligible)',
    link: 'https://amzn.to/3UgwkB7',
    id: 3,
  },
  {
    image: 'https://images.myloapp.in/NestJsUploads/1712766847149-Amazon5.webp',
    text: 'Clearblue Triple Assurance Pregnancy Test Kit, Home Pregnancy Tests, 3 Ways to Test, 3 Ct',
    link: 'https://amzn.to/3JkS60a',
    id: 4,
  },
];

export const dataFor167722 = {
  body: `<p>
    If you have just found out that you are pregnant and are
    wondering how stomach feels in early pregnancy, then you are not
    alone. Pregnancy invokes a heightened sense of curiosity, where
    you become more conscious about your body changes. Most women
    are eager to know about the early signs of pregnancy, and how to
    self examine your stomach for pregnancy.
    </p>
    ${renderToString(<AmazonCard data={carouselData167722[0]} />)}
    <p>
    Early pregnancy detection helps the lady mentally prepare for
    the big event and accordingly make better choices in diet and
    lifestyle. In this article, we will explore all the facts
    regarding how does your lower stomach feel in early pregnancy.
    </p>
    
    <h2>
    <strong>What are the Initial Signs of Pregnancy? </strong>
    </h2>
    
    <p>
    The egg&#39;s successful fertilization is warmly celebrated by
    the body as the hormones start dancing and bring many
    physiological changes. Missing your period is often the first
    notable sign of pregnancy which may be followed by
    <a href="http://mylofamily.com/article/what-are-the-early-symptoms-of-pregnancy-before-missed-period-163652">
        early pregnancy symptoms
    </a>
    like sore breasts, cramps, bloating, and fatigue. Some women
    also complain of increased urination, nausea, and increased
    sense of smell.
    </p>
    ${renderToString(<AmazonCard data={carouselData167722[1]} />)}
    <p>
    There are a lot many ladies who feel no different, while some
    others say it&#39;s hard to tell whether these symptoms are due
    to PMS (premenstrual syndrome) or pregnancy. To avoid confusion,
    knowing how to check your stomach for early pregnancy can be
    handy.
    </p>
    
    <h2>
    <strong>How Stomach Feels in Early Pregnancy?</strong>
    </h2>
    
    <p>
    If you are struggling to understand how does your lower stomach
    feel in early pregnancy, then scan the below lines and let the
    mystery unfold. You may observe some of the changes like:
    </p>
    ${renderToString(<AmazonCard data={carouselData167722[2]} />)}
    <h3>1. Mild cramping</h3>
    
    <p>
    Your early pregnancy bump is not really a bump and only you can
    notice the difference. The reason is abdominal bloating and
    cramping in the early pregnancy which might make it feel
    slightly fuller than usual. The abdominal cramps are the same as
    period cramps and the process is regarded as
    <a href="http://mylofamily.com/article/is-it-implantation-bleeding-%E2%80%94-or-just-my-period-1546?">
        implantation cramping
    </a>
    . These cramps are usually felt when the fertilized egg attaches
    itself to the uterine lining.
    </p>
    
    <h3>2. Bloating</h3>
    
    <p>
    A few moms-to-be report that their tummy feels soft but a bit
    bigger than usual.
    <a href="http://mylofamily.com/article/are-you-aware-of-the-symptoms-and-causes-of-pregna-25186?">
        Bloating
    </a>
    makes your tummy expand a little like it happens before a period
    or after a scrumptious meal. Additionally, women may experience
    a feeling of fullness as the uterus expands and begins to exert
    pressure on the surrounding organs.
    </p>
    
    <h3>3. Twinges and Pulling Sensations</h3>
    
    <p>
    In early pregnancy, some women experience a random pulling
    sensation from inside or a sharp pain as the supporting
    ligaments stretch and remodel themselves.
    </p>
    
    <p>
    You may also like:
    <a href="https://mylofamily.com/article/ways-to-perform-a-natural-pregnancy-test-at-home-without-using-a-pregnancy-test-kit-163377">
        Ways to perform a natural pregnancy test at home without
        using a pregnancy test kit
    </a>
    </p>
    ${renderToString(<AmazonCard data={carouselData167722[3]} />)}
    <h2>
    <strong>Why is Self-Examination a Good Option?</strong>
    </h2>
    
    <p>
    The sure shot way to confirm your conception is through a
    <a href="https://amzn.to/3VS3jNw">
        First Response Early Result Pregnancy Test Kit
    </a>
    , but at times you might not have access to self-testing kits.
    While lying in your bed you might wonder how does your lower
    stomach feel in early pregnancy. Then one of the best options is
    to understand how to self examine your stomach for pregnancy.
    </p>
    
    <p>
    Self-examination offers many benefits ranging from increased
    awareness about your body to incorporating healthy diet and
    lifestyle choices. This technique enables you to identify the
    early signs and can help you make informed decisions for a
    brighter future. Having said that, it is essential to remember
    that self-examination is not a substitute for pregnancy tests or
    medical advice.
    If you think you are expecting, then it is best to consult your
    healthcare provider at the soonest.
    </p>
    
    <p>
    How do you feel your uterus in early pregnancy is a common
    concern. Feeling the uterus by examining your stomach has been
    practised traditionally to self-test for pregnancy.
    
    It is one of the early signs of pregnancy as the uterus is
    making room for the developing fetus which can be called a
    little bump in your abdomen. An important thing to remember is
    that it is hard to notice during the early stages.
    </p>
    
    <p>
    The uterus becomes more evident when it grows out of the pelvis,
    but again you must know its location and how it feels otherwise.
    
    If you are expecting, you can anticipate a firmer abdomen as the
    expanding uterus puts pressure on the surrounding organs. A
    usual touch on your tummy might not be able to provide you with
    any confirming details. Knowing about how stomach feels in early
    pregnancy is more effective after you enter your second
    trimester.
    </p>
    
    <p>
    You may also like:
    <a href="https://mylofamily.com/article/after-how-many-days-of-sex-can-you-check-for-pregnancy-163503">
        After how many days of sex can you check for pregnancy?
    </a>
    </p>
    ${renderToString(<AmazonCard data={carouselData167722[4]} />)}
    <h2>
    <strong>How to Check Your Stomach for Early Pregnancy?</strong>
    </h2>
    
    <p>
    
    The right way to check pregnancy by examining your stomach
    includes locating the hard, developing uterus. So, if you want
    to know how to feel your uterus in early pregnancy, you can
    follow these steps:
    </p>
    
    <ul>
    <li>
        <p>
            It is essential to follow the correct protocol if you
            are looking for the answer of how do you feel your
            uterus in early pregnancy. You can locate your
            developing uterus by following the below-mentioned
            steps:
        </p>
    </li>
    <li>
        <p>
            Before the self-examination process, it is essential to
            empty your bladder.
        </p>
    </li>
    <li>
        <p>
            The ideal position is one where you are lying on your
            back with your knees bent and your feet should be placed
            flat on the bed.
        </p>
    </li>
    <li>
        <p>
            Inhale slowly and deeply and relax. You must remain calm
            as the process gives more accurate results with a
            stress-free mindset.
        </p>
    </li>
    <li>
        <p>
            Keep your fingers towards the right while your elbows
            are pointing towards the left, place the flat side of
            your left hand at the centre of your tummy, exactly
            above and near the pubic bone.
        </p>
    </li>
    <li>
        <p>
            Place your right hand over the pubic bone where your
            fingers are positioned towards the bone and your left
            palm offers support to your belly.
        </p>
    </li>
    <li>
        <p>
            Examine as your fingers are gently moving over your
            tummy while you softly push your feet.
        </p>
    </li>
    <li>
        <p>
            You may feel a semi-firm ball that is a little firm and
            is unlike your bowels. You can find the apex of the
            uterus just behind the pubic bone.
        </p>
    </li>
    <li>
        <p>
            Don&rsquo;t try too hard if you are unable to feel your
            womb even after a few attempts. Have patience and wait
            for some time till the womb rises above the pelvic
            cavity.
        </p>
    </li>
    </ul>
    
    <h2>
    <strong>
        What Could Be the Reason You Couldn&rsquo;t Feel Your
        Uterus?
    </strong>
    </h2>
    
    <p>
    Even after following all the steps carefully, chances are you
    may not hit the bullseye, while you are exploring how to feel
    your uterus in early pregnancy. One of the biggest reasons is
    that your uterus might be still very small to become
    identifiable during palpation, especially during the initial few
    weeks.
    </p>
    
    <p>
    Besides that, if your uterus prefers the tilted position then
    also the stakes are high that you may miss it while
    self-examining. Also, excessive body fat, gas or bloating and
    incorrect technique can contribute to the challenges. You must
    consider that self-examination can never replace a
    <a href="https://mylofamily.com/article/how-do-doctors-check-for-pregnancy-163518">
        medical pregnancy test
    </a>
    and it is always recommended to consult your doctor at the
    earliest.
    </p>
    
    <p style="text-align:center">
    <iframe
        frameborder="0"
        height="167"
        sandbox="allow-scripts allow-same-origin"
        scrolling="no"
        src="https://www.youtube.com/embed/84UGVRt-ZfQ"
        title="YouTube video player"
        width="315"
    ></iframe>
    </p>
    
    <h2>
    <strong>Conclusion</strong>
    </h2>
    
    <p>
    Pregnancy is a beautiful journey in which learning about the
    initial changes and early interventions can go a long way in
    making more informed decisions. Learning how to self examine
    your stomach for pregnancy can prove effective in identifying
    early pregnancy and seeking timely antenatal care. This method
    can be more accurate if performed by following all the necessary
    steps. Self-examination is a no-harm technique to check for
    early pregnancy however, it cannot replace the medical pregnancy
    test kits or seeking expert guidance. If you are anticipating
    conception, it is a good time to see your gynecologist.
    </p>
    
    <h3>References</h3>
    
    <p>
    1. Soma-Pillay P, Nelson-Piercy C, Tolppanen H, Mebazaa A.
    (2016). Physiological changes in pregnancy. Cardiovasc J Afr.
    NCBI
    </p>
    
    <p>
    2. Bachmann GA. Myth or fact: can women self-diagnose pregnancy?
    (1984). J Med Soc N J. NCBI
    </p>
    
    <p>
    <strong>Tags</strong>
    </p>
    
    <p>
    <a href="https://mylofamily.com/bn/article/%E0%A6%97%E0%A6%B0%E0%A7%8D%E0%A6%AD%E0%A6%BE%E0%A6%AC%E0%A6%B8%E0%A7%8D%E0%A6%A5%E0%A6%BE%E0%A6%B0-%E0%A6%B6%E0%A7%81%E0%A6%B0%E0%A7%81%E0%A6%A4%E0%A7%87-%E0%A6%A8%E0%A6%BF%E0%A6%9C%E0%A7%87%E0%A6%B0-%E0%A6%AA%E0%A7%87%E0%A6%9F-%E0%A6%95%E0%A7%80%E0%A6%AD%E0%A6%BE%E0%A6%AC%E0%A7%87-%E0%A6%AA%E0%A6%B0%E0%A7%80%E0%A6%95%E0%A7%8D%E0%A6%B7%E0%A6%BE-%E0%A6%95%E0%A6%B0%E0%A6%AC%E0%A7%87%E0%A6%A8-169674">
        How to Self Examine Your Stomach for Pregnancy in Bengali
    </a>
    
    <a href="https://mylofamily.com/ta/article/%E0%AE%AA%E0%AE%BF%E0%AE%B0%E0%AE%95%E0%AF%8D%E0%AE%A9%E0%AE%A9%E0%AF%8D%E0%AE%B8%E0%AE%BF%20-%20%E0%AE%9A%E0%AF%86%E0%AE%B2%E0%AF%8D%E0%AE%83%E0%AE%AA%E0%AF%8D%20%E0%AE%8E%E0%AE%95%E0%AF%8D%E0%AE%B8%E0%AE%AE%E0%AF%88%E0%AE%A9%E0%AF%8D%20%E0%AE%9F%E0%AF%86%E0%AE%95%E0%AF%8D%E0%AE%A9%E0%AE%BF%E0%AE%95%E0%AF%8D%E0%AE%95%E0%AF%81%E0%AE%95%E0%AE%B3%E0%AF%8D-189500">
        How to Self Examine Your Stomach for Pregnancy in Tamil
    </a>
    
    <a href="https://mylofamily.com/te/article/%E0%B0%AA%E0%B1%8D%E0%B0%B0%E0%B1%86%E0%B0%97%E0%B1%8D%E0%B0%A8%E0%B1%86%E0%B0%A8%E0%B1%8D%E0%B0%B8%E0%B1%80%E0%B0%A8%E0%B0%BF-%E0%B0%95%E0%B0%A8%E0%B1%8D%E0%B0%AB%E0%B0%B0%E0%B1%8D%E0%B0%AE%E0%B1%8D-%E0%B0%9A%E0%B1%87%E0%B0%B8%E0%B1%81%E0%B0%95%E0%B1%8B%E0%B0%B5%E0%B0%A1%E0%B0%BE%E0%B0%A8%E0%B0%BF%E0%B0%95%E0%B0%BF-%E0%B0%AE%E0%B1%80-%E0%B0%AA%E0%B1%8A%E0%B0%9F%E0%B1%8D%E0%B0%9F%E0%B0%A8%E0%B0%BF-%E0%B0%8E%E0%B0%B2%E0%B0%BE-%E0%B0%AA%E0%B0%B0%E0%B1%80%E0%B0%95%E0%B1%8D%E0%B0%B7-%E0%B0%9A%E0%B1%87%E0%B0%B8%E0%B1%81%E0%B0%95%E0%B1%8B%E0%B0%B5%E0%B0%BE%E0%B0%B2%E0%B1%8B-%E0%B0%A4%E0%B1%86%E0%B0%B2%E0%B1%81%E0%B0%B8%E0%B1%81%E0%B0%95%E0%B1%8B%E0%B0%82%E0%B0%A1%E0%B0%BF-225599">
        How to Self Examine Your Stomach for Pregnancy in Telugu
    </a>
    </p>`,
  carouselData: carouselData167722,
};

const carouselDataFor192289 = [
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1713160682432-pregnancyPillow1.webp',
    text: 'Momcozy Pregnancy Pillows for Sleeping, U Shaped Full Body Maternity Pillow with Removable Cover - Support for Back, Legs, Belly, HIPS for Pregnant Women, 57 Inch Pregnancy Pillow for Women, Grey',
    link: 'https://amzn.to/3VUEb8N',
    id: 0,
  },
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1713160682432-pregnancyPillow2.webp',
    text: 'QUEEN ROSE Pregnancy Pillow, U Shaped Full Body Pillows for Sleeping Support, 55 Inch Maternity Pillow for Pregnant Women with Cooling Silky Cover, Blue',
    link: 'https://amzn.to/3xykqcN',
    id: 1,
  },
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1713160682431-pregnancyPillow3.webp',
    text: 'Chilling Home Pregnancy Pillows, U Shaped Full Body Maternity Pillow 58 inch, Pregnant Women Must Haves Pregnancy Pillows for Sleeping with Removable Cover',
    link: 'https://amzn.to/3TSPdIW',
    id: 2,
  },
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1713160682431-pregnancyPillow4.webp',
    text: "Sasttie Pregnancy Pillows for Sleeping, U Shaped Body Pillow Pregnancy Must Haves, Maternity Pillow for Pregnant Women, 59'' Full Pregnant Pillow with Removable Cover for Side Sleeper, Light Grey",
    link: 'https://amzn.to/3TYKnKb',
    id: 3,
  },
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1713160682428-pregnancyPillow5.webp',
    text: '60 Inch Full Body Pregnancy Pillows for Sleeping Cooling Pregnancy Pillow,U Shaped Pregnancy Body Pillow,Maternity Pillows for Pregnant Women with Removable Washable Velvet Cover.',
    link: 'https://amzn.to/3vVKb6z',
    id: 4,
  },
];

export const dataFor192289 = {
  body: `<p>Pregnancy brings about many changes in a woman&#39;s body. It makes many parts of the body sensitive. From unexpected hair growth to constipation and belching, pregnancy causes many physical changes. Among these, gas is also a common occurrence among pregnant women. While it may seem embarrassing, it is nothing to be ashamed of. Smelly gas during pregnancy happens because of hormone surges.</p>

   <p>The good news is that the gas can be contolled. Although it cannot be completely done away with, there are some home remedies one can use to limit the gas or its smell. So, let&#39;s understand in detail about what causes gas problem during pregnancy and how to manage it.</p>
    
   <h2><strong>Is Gas an Early Pregnancy Sign? </strong></h2>
   ${renderToString(<AmazonCard data={carouselDataFor192289[0]} />)}
   <p>One of the most common signs of pregnancy is smelly gas and farting during <a href="https://mylofamily.com/article/first-trimester-of-pregnancy-183066?">early pregnancy</a>. This is nothing to be ashamed of. During the first week, a woman&#39;s body can become very gassy. Within the first two weeks of your first missed period, you may experience gassiness during early pregnancy.</p>
    
   <h2><strong>Is Smelly Gas During Pregnancy Normal? </strong></h2>
    
   <p>A pregnant woman&rsquo;s body doesn&rsquo;t have the same control as it did before pregnancy. This makes it harder to control muscle movements. The surge of hormones in the body causes her digestive system to swell up, which leads to pregnancy gas. Besides the discomfort caused by the buildup of gas, you may also experience abdominal pain, <a href="http://mylofamily.com/article/are-you-aware-of-the-symptoms-and-causes-of-pregna-25186?">bloating</a> and belching. And sorry to burst your bubble (pun intended), this may even last throughout the nine months of your pregnancy.  </p>
    
   <h2><strong>What Causes Farting During Pregnancy? </strong></h2>
   ${renderToString(<AmazonCard data={carouselDataFor192289[1]} />)}
   <p>There can be several reasons behind farting and <a href="http://mylofamily.com/article/gas-during-pregnancy-150215">excessive gas</a> during pregnancy, including: </p>
    
   <h3>1. Increased levels of progesterone</h3>
    
   <p>The hormone progesterone is responsible for relaxing muscles in the body, including those in your digestive tract. As the hormone levels increase, the digestion process slows down and leads to gas buildup and bloating.</p>
    
   <h3>2. Hormonal changes</h3>
    
   <p>Pregnancy hormones can affect the gastrointestinal system, causing changes in digestion and gas production. These hormonal fluctuations can contribute to increased pregnancy farts.</p>
    
   <h3>3. Pressure from the growing uterus</h3>
   ${renderToString(<AmazonCard data={carouselDataFor192289[2]} />)}
   <p>As your uterus expands to make room for the growing baby, it exerts pressure on the surrounding organs like the intestines. This increased pressure gives birth to gas and bloating.</p>
    
   <h3>4. Dietary factors</h3>
    
   <p>Some foods like beans, broccoli, cabbage, onions, lentils and carbonated drinks are known to cause gas. Consuming them during pregnancy can lead to excessive farting. </p>
    
   <h3>5. Reduced physical activity</h3>
    
   <p>Constant fatigue and numerous discomforts during pregnancy can cause you to limit your physical activity. Lesser physical movement can slow down your digestion and lead to more gas in the body. </p>
    
   <h2><strong>How to Relieve Gas Problem During Pregnancy? </strong></h2>
   ${renderToString(<AmazonCard data={carouselDataFor192289[3]} />)}
   <p>Farting during early pregnancy isn&rsquo;t something to be ashamed of or be concerned about, nonetheless, there are ways to address it. Smelly gas during pregnancy is usually caused by consuming improper food and drinks. Keeping a food log can help you understand which foods trigger your gas and then you can avoid them accordingly.</p>
    
   <p>Besides being mindful of what you&rsquo;re eating, also pay attention to your speed. Eat slowly, chew your food well and avoid gulping in excess air to reduce the chances of gas getting trapped inside your body. Additionally, increase your intake of fluids and cut down on sweetened and carbonated drinks.</p>
    
   <p>We know ladies this early pregnancy odour of gas can be bothersome, but here are some <a href="http://mylofamily.com/article/special-home-remedies-for-gas-during-pregnancy-1694">home remedies</a> to reduce the odour and gas during pregnancy. Start by drinking fluids frequently, including water and fresh juices. Also, be mindful of taking more fibre and fibre supplements.</p>
    
   <h2><strong>Will a Gas Problem Affect Pregnancy? </strong></h2>
   ${renderToString(<AmazonCard data={carouselDataFor192289[4]} />)}
   <p>Discomfort is commonly felt amongst pregnant women as they tend to get bloated or trap gas due to the hormones released during pregnancy. However, these symptoms do not affect the baby or the pregnancy cycle as such. Please consult your doctor in case the gas lasts for a long duration, or if it is accompanied with severe abdominal pain.</p>
    
   <p>You may also like: <a href="https://mylofamily.com/article/avoid-these-foods-to-fight-bloating-during-pregnan-25295">Which Foods Should You Avoid During Pregnancy That Cause Bloating?</a></p>
    
   <h3><strong>Conclusion </strong></h3>
    
   <p>Pregnancy gas may last for a few months, or the entire pregnancy cycle, especially since it occurs because of the release of hormones. Some women experience frequent farting during pregnancy, but this happens mainly because they do not focus on their food and water intake. To avoid bloating, belching and smelly gas during pregnancy, drink lots of water, eat foods with fibres or take fibre supplements, and ensure that your body gets plenty of physical exercise. While you can&#39;t avoid gas build up, you can relieve yourself from the gas, or limit the amount that gets trapped in your body.</p>
    
   <h3>References</h3>
    
   <p>1. Body changes and discomforts. (2021). The U.S. Department of Health and Human Services</p>
    
   <p>2. Longo SA, Moore RC, Canzoneri BJ, Robichaux A. (2010). Gastrointestinal Conditions during Pregnancy. NCBI</p>
    
   <p>3. Gas in the Digestive Tract; The National Institute of Diabetes and Digestive and Kidney Diseases; The National Institutes of Health</p>
   `,
  carouselData: carouselDataFor192289,
};
const carouselData168665 = [
  {
    image: 'https://images.myloapp.in/NestJsUploads/1713163587901-diaper1.webp',
    text: 'Huggies Newborn Diapers, Little Snugglers Disposable Diapers, 144 Count',
    link: 'https://amzn.to/3U1gWHD',
    id: 0,
  },
  {
    image: 'https://images.myloapp.in/NestJsUploads/1713163587900-diaper2.webp',
    text: 'Pampers Pure Protection Diapers - Size 1, One Month Supply (198 Count), Hypoallergenic Premium Disposable Baby Diapers',
    link: 'https://amzn.to/3VU8TPl',
    id: 1,
  },
  {
    image: 'https://images.myloapp.in/NestJsUploads/1713163587900-diaper3.webp',
    text: 'Pampers Baby Dry Diapers Newborn - Size 0, 104 Count, Absorbent Disposable Diapers',
    link: 'https://amzn.to/3U1MtsK',
    id: 2,
  },
  {
    image: 'https://images.myloapp.in/NestJsUploads/1713163587899-diaper4.webp',
    text: 'Pampers Swaddlers Diapers Newborn - Size 0, 84 Count (Pack of 1), Ultra Soft Disposable Baby Diapers',
    link: 'https://amzn.to/3JoieHq',
    id: 3,
  },
  {
    image: 'https://images.myloapp.in/NestJsUploads/1713163587897-diaper5.webp',
    text: 'Pampers Swaddlers Sensitive Newborn Diapers Size 0, 27 Count',
    link: 'https://amzn.to/3JkgKOE',
    id: 4,
  },
];
const carouselData168499 = [
  {
    image: 'https://images.myloapp.in/NestJsUploads/1713163587901-diaper1.webp',
    text: 'Huggies Newborn Diapers, Little Snugglers Disposable Diapers, 144 Count',
    link: 'https://amzn.to/4aADu8T',
    id: 0,
  },
  {
    image: 'https://images.myloapp.in/NestJsUploads/1713163587900-diaper2.webp',
    text: 'Pampers Pure Protection Diapers - Size 1, One Month Supply (198 Count), Hypoallergenic Premium Disposable Baby Diapers',
    link: 'https://amzn.to/49CzIL7',
    id: 1,
  },
  {
    image: 'https://images.myloapp.in/NestJsUploads/1713163587900-diaper3.webp',
    text: 'Pampers Baby Dry Diapers Newborn - Size 0, 104 Count, Absorbent Disposable Diapers',
    link: 'https://amzn.to/3Q271A5',
    id: 2,
  },
  {
    image: 'https://images.myloapp.in/NestJsUploads/1713163587899-diaper4.webp',
    text: 'Pampers Swaddlers Diapers Newborn - Size 0, 84 Count (Pack of 1), Ultra Soft Disposable Baby Diapers',
    link: 'https://amzn.to/3Q3wlGd',
    id: 3,
  },
  {
    image: 'https://images.myloapp.in/NestJsUploads/1713163587897-diaper5.webp',
    text: 'Pampers Swaddlers Sensitive Newborn Diapers Size 0, 27 Count',
    link: 'https://amzn.to/4cXdzK7',
    id: 4,
  },
];
export const dataFor168665 = {
  body: `<p>Searching for a nice baby name over internet or from books is not only tedious but confusing too. The best way is to have a checklist in hand that can specify your choices. For instance, if you are considering girl baby names in Tamil for your beloved daughter, then you can jot down your shortlisted names. Whether you prefer Hindu baby girl names in Tamil, or pure Tamil baby girl names or modern Tamil girl baby names, such checklist works as a ready reminder and makes your name finding task not only simpler but quicker too.    </p>

    <p>In this article, we have shortlisted over 120 latest baby girl names in Tamil with their meanings so that you can choose the best one for your little one.   </p>
    
    <h2><strong>Girl Baby Names in Tamil A to Z  </strong></h2>
    
    <p>Whether you&#39;re looking for unique Tamil baby girl names or Tamil trending names for girl baby, we have curated an extensive list of beautiful Tamil names for girl baby that will surely serve your purpose: </p>
    
    <table border="0">
        <tbody>
            <tr>
                <td>
                <p><strong>Name</strong> </p>
                </td>
                <td>
                <p><strong>Meaning </strong></p>
                </td>
            </tr>
        
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-aadhira-80" rel="noreferrer noopener" target="_blank">Aadhira</a> </p>
                </td>
                <td>
                <p>Moonlight </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-aarna-58" rel="noreferrer noopener" target="_blank">Aarna</a> </p>
                </td>
                <td>
                <p>Goddess Lakshmi </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-abhirami-1106" rel="noreferrer noopener" target="_blank">Abhirami</a> </p>
                </td>
                <td>
                <p>Goddess Parvati </p>
                </td>
            </tr>
            
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-aishwarya-2237" rel="noreferrer noopener" target="_blank">Aishwarya</a> </p>
                </td>
                <td>
                <p>Goddess Lakshmi, Wealth and Prosperity </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-akila-537" rel="noreferrer noopener" target="_blank">Akila</a> </p>
                </td>
                <td>
                <p>Intelligent, Wise </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-akshaya-362" rel="noreferrer noopener" target="_blank">Akshaya</a> </p>
                </td>
                <td>
                <p>Immortal </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-amara-283" rel="noreferrer noopener" target="_blank">Amara</a> </p>
                </td>
                <td>
                <p>Immortal </p>
                </td>
            </tr>
            </table>
            ${renderToString(<AmazonCard data={carouselData168665[0]} />)}
            <table border="0">
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-amritha-6090" rel="noreferrer noopener" target="_blank">Amritha</a> </p>
                </td>
                <td>
                <p>Immortal </p>
                </td>
            </tr>
        
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-ananya-94" rel="noreferrer noopener" target="_blank">Ananya</a> </p>
                </td>
                <td>
                <p>Unique, Incomparable </p>
                </td>
            </tr>
            <tr>
                <td>
                <p>Anika </p>
                </td>
                <td>
                <p>Grace </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-anjali-292" rel="noreferrer noopener" target="_blank">Anjali</a> </p>
                </td>
                <td>
                <p>Offering </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-anusha-399" rel="noreferrer noopener" target="_blank">Anusha</a> </p>
                </td>
                <td>
                <p>Beautiful morning </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-anushka-330" rel="noreferrer noopener" target="_blank">Anushka</a> </p>
                </td>
                <td>
                <p>A term of endearment </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-aparna-329" rel="noreferrer noopener" target="_blank">Aparna</a> </p>
                </td>
                <td>
                <p>Goddess Parvati </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-aradhana-1875" rel="noreferrer noopener" target="_blank">Aradhana</a> </p>
                </td>
                <td>
                <p>Worship </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-aruna-2043" rel="noreferrer noopener" target="_blank">Aruna</a> </p>
                </td>
                <td>
                <p>Reddish brown </p>
                </td>
            </tr>
          
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-ashita-2200" rel="noreferrer noopener" target="_blank">Ashita</a> </p>
                </td>
                <td>
                <p>Someone who brings hope </p>
                </td>
            </tr>
            </table>
            ${renderToString(<AmazonCard data={carouselData168665[1]} />)}
            <table border="0">
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-bhavana-11626" rel="noreferrer noopener" target="_blank">Bhavana</a> </p>
                </td>
                <td>
                <p>Meditation </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-bhavika-11538" rel="noreferrer noopener" target="_blank">Bhavika</a> </p>
                </td>
                <td>
                <p>Well-behaved </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-charul-16672" rel="noreferrer noopener" target="_blank">Charul</a> </p>
                </td>
                <td>
                <p>Beautiful </p>
                </td>
            </tr>
            <tr>
                <td>
                
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-chitra-16614" rel="noreferrer noopener" target="_blank">Chitra</a> </p>
                </td>
                <td>
                <p>Picture, Painting </p>
                </td>
            </tr>
          
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-daksha-20595" rel="noreferrer noopener" target="_blank">Daksha</a> </p>
                </td>
                <td>
                <p>The Earth </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-darshini-20641" rel="noreferrer noopener" target="_blank">Darshini</a> </p>
                </td>
                <td>
                <p>The one who blesses </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-devika-20675" rel="noreferrer noopener" target="_blank">Devika</a> </p>
                </td>
                <td>
                <p>Little goddess </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-divya-20616" rel="noreferrer noopener" target="_blank">Divya</a> </p>
                </td>
                <td>
                <p>Divine </p>
                </td>
            </tr>
        
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-eesha-24911" rel="noreferrer noopener" target="_blank">Eesha</a> </p>
                </td>
                <td>
                <p>Goddess Parvati </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-elakkiyan-25288" rel="noreferrer noopener" target="_blank">Elakkiya</a> </p>
                </td>
                <td>
                <p>Well-spoken, Accomplished in literature </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-eshita-25122" rel="noreferrer noopener" target="_blank">Eshita</a> </p>
                </td>
                <td>
                <p>One who desires </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-eshwari-25170" rel="noreferrer noopener" target="_blank">Eshwari</a> </p>
                </td>
                <td>
                <p>Goddess Parvati </p>
                </td>
            </tr>
            </table>
            ${renderToString(<AmazonCard data={carouselData168665[2]} />)}
            <table border="0">
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-ganga-29617" rel="noreferrer noopener" target="_blank">Ganga</a> </p>
                </td>
                <td>
                <p>Holy river Ganges </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-gayathri-29934" rel="noreferrer noopener" target="_blank">Gayathri</a> </p>
                </td>
                <td>
                <p>Mother of the Vedas </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-gauri-29580" rel="noreferrer noopener" target="_blank">Gauri</a> </p>
                </td>
                <td>
                <p>Goddess Parvati </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-hansika-33218" rel="noreferrer noopener" target="_blank">Hansika</a> </p>
                </td>
                <td>
                <p>Swan </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-harini-33124" rel="noreferrer noopener" target="_blank">Harini</a> </p>
                </td>
                <td>
                <p>Deer </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-hema-33275" rel="noreferrer noopener" target="_blank">Hema</a> </p>
                </td>
                <td>
                <p>Golden </p>
                </td>
            </tr>
        
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-ishita-36775" rel="noreferrer noopener" target="_blank">Ishita</a> </p>
                </td>
                <td>
                <p>Mastery, Wealth </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-isha-36777" rel="noreferrer noopener" target="_blank">Isha</a> </p>
                </td>
                <td>
                <p>Goddess Durga </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-jaya-38805" rel="noreferrer noopener" target="_blank">Jaya</a> </p>
                </td>
                <td>
                <p>Victory </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-janani-37876" rel="noreferrer noopener" target="_blank">Janani</a> </p>
                </td>
                <td>
                <p>Mother </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-jyotsna-37779" rel="noreferrer noopener" target="_blank">Jyotsna</a> </p>
                </td>
                <td>
                <p>Moonlight </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-kavya-41418" rel="noreferrer noopener" target="_blank">Kavya</a> </p>
                </td>
                <td>
                <p>Poem </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-keerthana-41548" rel="noreferrer noopener" target="_blank">Keerthana</a> </p>
                </td>
                <td>
                <p>Devotional song </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-kiran-41500" rel="noreferrer noopener" target="_blank">Kiran</a> </p>
                </td>
                <td>
                <p>Ray of light </p>
                </td>
            </tr>
            <tr>
                <td>
                <p>Kirthiksha </p>
                </td>
                <td>
                <p>Goddess Parvati </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-kirti-42669" rel="noreferrer noopener" target="_blank">Kirti</a> </p>
                </td>
                <td>
                <p>Fame </p>
                </td>
            </tr>
            </table>
            ${renderToString(<AmazonCard data={carouselData168665[3]} />)}
            <table border="0">
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-krisha-41420" rel="noreferrer noopener" target="_blank">Krisha</a> </p>
                </td>
                <td>
                <p>Divine </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-lakshmi-46465" rel="noreferrer noopener" target="_blank">Lakshmi</a> </p>
                </td>
                <td>
                <p>Goddess of Wealth </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-latika-46504" rel="noreferrer noopener" target="_blank">Latika</a> </p>
                </td>
                <td>
                <p>Tendril </p>
                </td>
            </tr>
            <tr>
                <td>
                <p>Lekha </p>
                </td>
                <td>
                <p>Writing </p>
                </td>
            </tr>
            <tr>
                <td>
                <p>Lithanya </p>
                </td>
                <td>
                <p>Goddess Lakshmi </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-mahika-49483" rel="noreferrer noopener" target="_blank">Mahika</a> </p>
                </td>
                <td>
                <p>Dew drops </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-meera-49651" rel="noreferrer noopener" target="_blank">Meera</a> </p>
                </td>
                <td>
                <p>Devotee of Lord Krishna </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-nandhini-55761" rel="noreferrer noopener" target="_blank">Nandhini</a> </p>
                </td>
                <td>
                <p>Goddess Durga </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-nandini-55750" rel="noreferrer noopener" target="_blank">Nandini</a> </p>
                </td>
                <td>
                <p>Daughter, Goddess Durga </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-navya-55621" rel="noreferrer noopener" target="_blank">Navya</a> </p>
                </td>
                <td>
                <p>New </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-neha-55604" rel="noreferrer noopener" target="_blank">Neha</a> </p>
                </td>
                <td>
                <p>Love </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-nila-55827" rel="noreferrer noopener" target="_blank">Nila</a> </p>
                </td>
                <td>
                <p>Moonlight </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-oviya-59462" rel="noreferrer noopener" target="_blank">Oviya</a> </p>
                </td>
                <td>
                <p>Artist </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-pavithra-60833" rel="noreferrer noopener" target="_blank">Pavithra</a> </p>
                </td>
                <td>
                <p>Pure, Sacred </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-pooja-60585" rel="noreferrer noopener" target="_blank">Pooja</a> </p>
                </td>
                <td>
                <p>Worship </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-poojasri-60825" rel="noreferrer noopener" target="_blank">Poojasri</a> </p>
                </td>
                <td>
                <p>Goddess Lakshmi </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-priya-60583" rel="noreferrer noopener" target="_blank">Priya</a> </p>
                </td>
                <td>
                <p>Beloved </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-priyanka-60542" rel="noreferrer noopener" target="_blank">Priyanka</a> </p>
                </td>
                <td>
                <p>Beautiful, Lovable </p>
                </td>
            </tr>
            <tr>
                <td>
                <p>Puviksha </p>
                </td>
                <td>
                <p>Mother of Earth </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-raagini-64986" rel="noreferrer noopener" target="_blank">Raagini</a> </p>
                </td>
                <td>
                <p>Melody </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-radha-64694" rel="noreferrer noopener" target="_blank">Radha</a> </p>
                </td>
                <td>
                <p>Success </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-radhika-64797" rel="noreferrer noopener" target="_blank">Radhika</a> </p>
                </td>
                <td>
                <p>Successful </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-ria-64640" rel="noreferrer noopener" target="_blank">Ria</a> </p>
                </td>
                <td>
                <p>Graceful, Singer </p>
                </td>
            </tr>
            </table>
            ${renderToString(<AmazonCard data={carouselData168665[4]} />)}
            <table border="0">
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-rithika-64714" rel="noreferrer noopener" target="_blank">Rithika</a> </p>
                </td>
                <td>
                <p>Joyful </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-saanvi-68777" rel="noreferrer noopener" target="_blank">Saanvi</a> </p>
                </td>
                <td>
                <p>Goddess Lakshmi </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-sanjana-68991" rel="noreferrer noopener" target="_blank">Sanjana</a> </p>
                </td>
                <td>
                <p>Gentle </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-sarika-69108" rel="noreferrer noopener" target="_blank">Sarika</a> </p>
                </td>
                <td>
                <p>Parrot </p>
                </td>
            </tr>
            <tr>
                <td>
                <p>Sastika </p>
                </td>
                <td>
                <p>Lord Murugan </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-shreya-68812" rel="noreferrer noopener" target="_blank">Shreya</a> </p>
                </td>
                <td>
                <p>Auspicious </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-shruti-68858" rel="noreferrer noopener" target="_blank">Shruti</a> </p>
                </td>
                <td>
                <p>Musical note </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-sneha-68990" rel="noreferrer noopener" target="_blank">Sneha</a> </p>
                </td>
                <td>
                <p>Affection </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-sri-69804" rel="noreferrer noopener" target="_blank">Sri</a> </p>
                </td>
                <td>
                <p>Radiance, Diffusing Light </p>
                </td>
            </tr>
            <tr>
                <td>
                <p>Srinika </p>
                </td>
                <td>
                <p>Goddess Lakshmi </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-sruthi-70269" rel="noreferrer noopener" target="_blank">Sruthi</a> </p>
                </td>
                <td>
                <p>Musical note </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-suhana-68841" rel="noreferrer noopener" target="_blank">Suhana</a> </p>
                </td>
                <td>
                <p>Beautiful </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-tanisha-78870" rel="noreferrer noopener" target="_blank">Tanisha</a> </p>
                </td>
                <td>
                <p>Ambition </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-tanvi-77786" rel="noreferrer noopener" target="_blank">Tanvi</a> </p>
                </td>
                <td>
                <p>Goddess Durga </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-trisha-77793" rel="noreferrer noopener" target="_blank">Trisha</a> </p>
                </td>
                <td>
                <p>Thirst </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-thiya-77810" rel="noreferrer noopener" target="_blank">Thiya</a> </p>
                </td>
                <td>
                <p>Gift of God </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-uthra-81362" rel="noreferrer noopener" target="_blank">Uthra</a> </p>
                </td>
                <td>
                <p>Prosperity </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-vaishali-81965" rel="noreferrer noopener" target="_blank">Vaishali</a> </p>
                </td>
                <td>
                <p>Historical city in India </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-vaishnavi-81922" rel="noreferrer noopener" target="_blank">Vaishnavi</a> </p>
                </td>
                <td>
                <p>Goddess Lakshmi </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-vani-81914" rel="noreferrer noopener" target="_blank">Vani</a> </p>
                </td>
                <td>
                <p>Goddess Saraswati </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-varsha-82000" rel="noreferrer noopener" target="_blank">Varsha</a> </p>
                </td>
                <td>
                <p>Rain </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-vasudha-82106" rel="noreferrer noopener" target="_blank">Vasudha</a> </p>
                </td>
                <td>
                <p>Earth </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-vedika-81897" rel="noreferrer noopener" target="_blank">Vedika</a> </p>
                </td>
                <td>
                <p>Consciousness </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-vidya-82068" rel="noreferrer noopener" target="_blank">Vidya</a> </p>
                </td>
                <td>
                <p>Knowledge </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-yamini-84047" rel="noreferrer noopener" target="_blank">Yamini</a> </p>
                </td>
                <td>
                <p>Night </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-yoshita-84014" rel="noreferrer noopener" target="_blank">Yoshita</a> </p>
                </td>
                <td>
                <p>Woman of fame </p>
                </td>
            </tr>
            <tr>
                <td>
                <p><a href="https://mylofamily.com/parenting/babynames/meaning-of-zara-84649" rel="noreferrer noopener" target="_blank">Zara</a> </p>
                </td>
                <td>
                <p>Princess </p>
                </td>
            </tr>
        </tbody>
    </table>
    
    <p>Find More <a href="https://mylofamily.com/parenting/babynames" rel="noreferrer noopener" target="_blank">Baby Names</a> Here! </p>
    
    <h3>Final Thoughts </h3>
    
    <p>We are sure that after reading these girl baby names in Tamil, you must have found a name that is close to your heart just as your daughter is. Whether you go for modern Tamil girl baby names, Tamil trending names for girl baby or pure Tamil baby girl names, may you and your daughter have a blissful journey ahead. God Bless! </p>
    `,
  carouselData: carouselData168665,
};

export const datafor168499 = {
  body: `<p>Right from the time you conceive, your baby becomes precious. Naming your child is equally exciting as it seems cumbersome. When you look for baby girl names, you might be specific about the alphabet it must start from or the sound of the name. You might want to keep it short and uncomplicated or you may have some traditional strings in mind. While shortlisting unique baby girl names, you can either be gender-specific or just broadly look for the latest baby girl names.</p>

    <p>To make your task easier and keep up with the latest trends, we have a list of all sorts of baby girl names with their meanings, that will surely get you to a beautiful name for your little angel.</p>
    
    <h2><strong>Baby Girl Names and Meanings</strong></h2>
    
    <table border="1" id="table1">
        <tbody>
            <tr>
                <th>Name</th>
                <th>Meaning</th>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-aadhira-80">Aadhira</a></td>
                <td>Lightning, Strong, The Moon, Moon, To sentimentalize and remember nostalgically</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-aadhya-67">Aadhya</a></td>
                <td>First power, Goddess Durga, First, Unequalled, Perfect, The earth, Another ornament, aadhya means the The first power, the Beginning, it is also an another name of Goddess Durga</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-aaditri-96">Aaditri</a></td>
                <td>Highest honor, Goddess Lakshmi, aaditri is another name of Goddess Laxmi, the person who brings wealth and prosperity</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-aadvika-50">Aadvika</a></td>
                <td>World, Earth, Unique, the word signifies the person who is Unique in all aspects</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-aahana-52">Aahana</a></td>
                <td>Inner light, Immortal, Born during the day, First rise of the Sun, The name aahana has the meaning of someone like Angel, someone sweet and charming like rose it also means First sun rays</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-aarna-58">Aarna</a></td>
                <td>Goddess Lakshmi, Water, Wave, Effervescing, Stream, this is an another name of Goddess Laxmi</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-aarohi-83">Aarohi</a></td>
                <td>A music tune, Progressive, Evolving, the musical note or being very sound</td>
            </tr>
            <table/>
            ${renderToString(<AmazonCard data={carouselData168665[0]} />)}
            <table border="1" id="table1">
            <tr>
                <td><a href="/parenting/babynames/meaning-of-aarvi-43">Aarvi</a></td>
                <td>Peace, The word has a meaning of peace, or the one who makes peace</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-aashvi-38">Aashvi</a></td>
                <td>Blessed and victorious, Little mare, One of many names of Goddess Saraswati</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-aavya-84">Aavya</a></td>
                <td>First rays of The Sun, Gift of God</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-advika-63">Advika</a></td>
                <td>World, Earth, Unique, A unique girl, no copy or duality</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-advita-106">Advita</a></td>
                <td>One or unique, First one. number one, Lovely</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-adya-46">Adya</a></td>
                <td>First power, Unparalleled, Great, Beyond perception, Goddess durga</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-amaya-73">Amaya</a></td>
                <td>Night rain, Immeasurable, Without limit, The beautiful night rain</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-amayra-74">Amayra</a></td>
                <td>Princess</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-amyra-91">Amyra</a></td>
                <td>Leader, Princess, Royal lady, The commander of the armed forces, a general and a born princess</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-anaisha-79">Anaisha</a></td>
                <td>Special</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-anaya-36">Anaya</a></td>
                <td>Without a superior, God has shown favour, Without a Superior, Look Up To God, Hebrew - God Answered, God was gracious, A variation of Aniya,</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-anika-62">Anika</a></td>
                <td>Goddess Durga, The brilliance of stone, Graceful young girl</td>
            </tr>
            <table />
            ${renderToString(<AmazonCard data={carouselData168665[1]} />)}
            <table border="1" id="table1">
            <tr>
                <td><a href="/parenting/babynames/meaning-of-anvi-48">Anvi</a></td>
                <td>One of devis names, Name of a Goddess, Goddess of forest, the one who is nature loving</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-anvika-44">Anvika</a></td>
                <td>Powerful and complete, The powerful and strong one</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-arika-65">Arika</a></td>
                <td>Beautiful, Goddess of Wealth and Prosperity, One of many names of Goddess Lakshmi</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-avika-78">Avika</a></td>
                <td>Sunrays, Charismatic personality, Bright as a Sun, charismatic personality, Diamond</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-avyuktha-69">Avyuktha</a></td>
                <td>Inexpressible, Crystal clear, One who has crystal clear heart</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-ayra-51">Ayra</a></td>
                <td>The beginning, The principle, The breathe of life</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-dhanvi-20573">Dhanvi</a></td>
                <td>Wealthy, A woman who is rich and wealthy. One of the names of Goddess Lakshmi.</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-dhvija-20571">Dhvija</a></td>
                <td>Borne for performing the great things, One who has taken birth to perform great things</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-dityaa-20570">Dityaa</a></td>
                <td>Answer of prayers, Another name for Lakshmi, Goddess Laxmi who answers the prayers</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-divisha-20574">Divisha</a></td>
                <td>Goddess Durga, Chief of the Goddess, Devee</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-driti-20582">Driti</a></td>
                <td>Courage, Morale, Steadiness, Command, Pleasure, Determination, Patience, Virtue</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-dviti-20599">Dviti</a></td>
                <td>Bright</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-eva-24891">Eva</a></td>
                <td>Life, Living one, Variant of eve, In the bible eve was adams wife and the first woman, Alive, Auspicious news, life or living one.</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-hritvi-33026">Hritvi</a></td>
                <td>Right guidance, Happy, Scholar, Lady Indian priest who full fill particularly completing the vedic haven</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-ira-36767">Ira</a></td>
                <td>A devoted one, Tender, Woman of magdala, To be present in latent, United, Noble (Celebrity Name: Amir Khan)</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-ishanvi-36768">Ishanvi</a></td>
                <td>Goddess Parvati, Goddess of knowledge</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-jisha-37651">Jisha</a></td>
                <td>The person having the highest feelings for living, the meaning of this name is person having high level of feeling and passion for living. Highly optimistic , artistic nature and have love for nature.</td>
            </tr>
            </table>
            ${renderToString(<AmazonCard data={carouselData168665[2]} />)}
            <table border="1" id="table1">
            <tr>
                <td><a href="/parenting/babynames/meaning-of-kaira-41412">Kaira</a></td>
                <td>Peaceful, Unique, Lady, Kaira means Peaceful and Unique</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-kashvi-41409">Kashvi</a></td>
                <td>Shining, Bright, Glowing, The name means Luminous</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-kayra-41403">Kayra</a></td>
                <td>Peaceful, Unique, Lady, Kayra means She is a Peaceful and Unique Girl</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-kiara-41405">Kiara</a></td>
                <td>Little black one, Dusky, Dark haired, Kiara means a Woman With Raven-Black, Dark Hair</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-mahira-49430">Mahira</a></td>
                <td>Highly skilled, Expert, Quick, Talented, Powerful, A knowledgeable, expert person</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-manasvi-49438">Manasvi</a></td>
                <td>Intelligent, Wise, Sensible, Self-respecting, Self-controlled, An intelligent person</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-mayra-49432">Mayra</a></td>
                <td>Beloved, Favorable, Admirable, Marvellous, A beloved girl</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-miraya-49434">Miraya</a></td>
                <td>Devotee of Lord Krishna (Celebrity Name: Priyanka Gandhi), Name of Lord Krishna&#39;s devotee, A variant spelling is Meera</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-misha-49435">Misha</a></td>
                <td>Happy for entire life, The message bearer from the God</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-mishika-49431">Mishika</a></td>
                <td>Love of God, The person with the sweetness of sugar</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-mishita-49439">Mishita</a></td>
                <td>Goddess Laxmi, Sweet person, A sweet person, Good nature, Also referred to Goddess Laxmi</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-mishka-49444">Mishka</a></td>
                <td>Gift of Love</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-mysha-49445">Mysha</a></td>
                <td>Happy for entire life</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-nainika-55600">Nainika</a></td>
                <td>Pupil of the eye, The one who has attractive and shining eyes.</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-naira-55598">Naira</a></td>
                <td>Shining, Glittering, The one having the bigger eyes</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-naisha-55603">Naisha</a></td>
                <td>Special, Lovely flower, A special or lovely flower</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-nirvi-55609">Nirvi</a></td>
                <td>Bliss, New comer to the family.</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-nitara-55595">Nitara</a></td>
                <td>Deeply rooted (Celebrity Names: Akshay Kumar and Twinkle Kumar), One who have the deep roots</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-niva-55599">Niva</a></td>
                <td>One of the 1000 names of river Narmada, The Sun, To talk or the expressions of talking</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-niya-55596">Niya</a></td>
                <td>A desire for something, Purpose, Bright, Lord Hanuman (Son of Anjani), The aim or desire of something</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-pranavi-60539">Pranavi</a></td>
                <td>Goddess Parvati, The first sound of universe aum called as Pranavi, One of the many names of Goddess Parvathi</td>
            </tr>
            </table>
            ${renderToString(<AmazonCard data={carouselData168665[3]} />)}
            <table border="1" id="table1">
            <tr>
                <td><a href="/parenting/babynames/meaning-of-pranshi-60537">Pranshi</a></td>
                <td>Goddess Lakshmi, Of great stature, A name of the Devi Laxmi</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-prisha-60535">Prisha</a></td>
                <td>Talent given by God, Beloved, Loving, Gods gift, Beloved, Loving, God&#39;s Gift, Dear</td>
            </tr>
            <tr>
                <td><a href="https://mylofamily.com/parenting/babynames/meaning-of-raha-66464">Raha</a></td>
                <td>Peaceful, peace of mind</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-ruhi-64609">Ruhi</a></td>
                <td>A music tune, Soul, A flower, Who touches the heart, One with a beutiful soul</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-rutvi-64601">Rutvi</a></td>
                <td>Name of An Angel meaning season, Love and saint, Speech</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-saanvi-68777">Saanvi</a></td>
                <td>Goddess Lakshmi, One who will be followed, Name of the Goddess Lakshmi</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-saanvika-68792">Saanvika</a></td>
                <td>Goddess Lakshmi, One who will be followed</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-saisha-68789">Saisha</a></td>
                <td>With great desire and wish, Truth of life</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-samaira-68784">Samaira</a></td>
                <td>Enchanting, Protected by God, Guardian (Celebrity Name: Karishma Kapoor), A compagnion in the converations led at night</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-shanaya-68780">Shanaya</a></td>
                <td>Eminent, Distinguished, Born on saturday, First Ray of the Sun</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-shanvika-68802">Shanvika</a></td>
                <td>Goddess Lakshmi, One who will be followed</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-shreenika-68781">Shreenika</a></td>
                <td>Lotus in the heart of Lord Vishnu, Goddess Lakshmi, Night</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-shreyanvi-68797">Shreyanvi</a></td>
                <td>Goddess Lakshmi, Goddess Durga</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-siara-68785">Siara</a></td>
                <td>Unique, A woman who is pure and holy</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-siya-68788">Siya</a></td>
                <td>Goddess Sita, White moonlight, A handsome woman, White doorvaa grass, Arabian Jasmine, Candied sugar, A woman sho always wins</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-srinika-68791">Srinika</a></td>
                <td>Goddess Lakshmi or lotus which is in the heart of Lord Vishnu</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-sudiksha-68814">Sudiksha</a></td>
                <td>Another name for Goddess Laxmi, Good start, Beautiful, Offering, Goddess lakshmi</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-tanishka-77789">Tanishka</a></td>
                <td>Goddess of gold, Daughter, Goddess of gold</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-tishya-77787">Tishya</a></td>
                <td>Auspicious, A star, Lucky, The sense of joy and happiness</td>
            </tr>
            </table>
            ${renderToString(<AmazonCard data={carouselData168665[4]} />)}
            <table border="1" id="table1">
            <tr>
                <td><a href="/parenting/babynames/meaning-of-trishika-77782">Trishika</a></td>
                <td>Goddess Lakshmi, Trident, One who is with pitchfork, Goddess Laxmi</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-vedika-81897">Vedika</a></td>
                <td>Full of knowledge, Altar, A river in India, Consciousness, An Apsara or celestial</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-viha-81902">Viha</a></td>
                <td>Heaven or angel</td>
            </tr>
            <tr>
                <td><a href="/parenting/babynames/meaning-of-vihana-81901">Vihana</a></td>
                <td>Early morning</td>
            </tr>
        </tbody>
    </table>
    
    <p>Find More <a href="https://mylofamily.com/parenting/babynames">Baby Names</a> Here!</p>
    
    <p>We hope that the above baby girl names serve as a guide for you to choose the perfect name for your little girl. Whether you are drawn towards the latest baby girl names or unique baby girl names that celebrate individuality, the most important thing is to choose a name that resonates with you and your family.</p>
    `,
  carouselData: carouselData168499,
};
export const getUsDataById = (articleId) => {
  switch (articleId) {
    case '167722':
      return dataFor167722;
    case '192289':
      return dataFor192289;
    case '168499':
      return datafor168499;
    case '168665':
      return dataFor168665;
    default:
      return '';
  }
};
export const dataSlots = [
  '6370316626',
  '1369011624',
  '7763863731',
  '3465526070',
  '2776294773',
  '7213199392',
  '4498943123',
  '9559698111',
  '5620453105',
  '7908222012',
  '8055044758',
  '9568788045',
];
